import React from 'react';
import Hero from './components/abstract/Hero';
import Main from './components/abstract/Main';

const Abstract = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Abstract;